export const WeekConvertor: { [key: number]: string } = {
    1: 'شنبه  ',
    2: 'یک شنبه ',
    3: 'دوشنبه ',
    4: 'سه شنبه ',
    5: 'چهارشنبه ',
    6: 'پنجشنبه ',
    7: 'جمعه ',
}
